module.exports = __webpack_public_path__ + "media/application/images/hamburger-menu-9506b7362e1f6bc53a4deb50e55c8691.svg";